export const DESKTOP_BREAKPOINT = 1024;
